import React from "react";
import Hero from "../Components/Hero";
import ScrollReveal from "../Components/ScrollReveal";
import HomeServices from "../Components/HomeServices";
import StatsCounter from "../Components/StatsCounter";
import HomeAbout from "../Components/HomeAbout";
import ProjectShowcase from "../Components/ProjectShowcase";
import Reviews from "../Components/Reviews";
import CTASection from "../Components/CTASection";
import Footer from "../Components/Footer";

function Home() {
  return (
    <div className="home-section">
      <Hero />
      <ScrollReveal>
        <HomeServices />
      </ScrollReveal>
      <ScrollReveal>
        <StatsCounter />
      </ScrollReveal>
      <ScrollReveal>
        <HomeAbout />
      </ScrollReveal>
      <ScrollReveal>
        <ProjectShowcase />
      </ScrollReveal>
      <ScrollReveal>
        <Reviews />
      </ScrollReveal>
      <ScrollReveal>
        <CTASection />
      </ScrollReveal>
      <Footer />
    </div>
  );
}

export default Home;
